import React, { Component, Suspense } from 'react';
import {
  AppHeader
} from '@coreui/react';

import { defaultProps } from 'recompose';


const RenterHeader = React.lazy(() => import('./RenterHeader'));

class SearchLayout extends Component {
  loading = () => (
    <div className="animated fadeIn pt-1 text-center">
      <div className="sk-spinner sk-spinner-pulse" />
    </div>
  );

  render() {
    return (
      <div className="app h-100vh">
        <AppHeader
          className='renter'
        >
          <Suspense fallback={this.loading()}>
            <RenterHeader {...this.props} />
          </Suspense>
        </AppHeader>

        <div className="app-body renter mt-0">
          <main className="main d-flex flex-column">
            <Suspense fallback={this.loading()}>
              {this.props.children}
            </Suspense>
          </main>
        </div>
      </div>
    )
  }
}

const withDefaults = defaultProps({
  routes: [],
  navigation: { items: [] }
});

export default withDefaults(SearchLayout);
